module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contenedor-datos"
  }, [(_vm.mostrarModalAdjuntar) ? _c('div', {
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.closeModalAdjuntar
    }
  }), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [_c('div', {
    staticClass: "overlay-class"
  }, [_c('upload-image', {
    attrs: {
      "name": "adjuntar_foto_perfil",
      "folder": "fotoPerfil",
      "onlyImg": true
    },
    on: {
      "save": _vm.guardarAdjunto,
      "close": _vm.closeModalAdjuntar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Adjuntar Foto de Perfil")]), _c('span', {
    attrs: {
      "slot": "explanation"
    },
    slot: "explanation"
  }, [_vm._v("Adjunta la imagen que deseas usar como foto de perfil")]), _c('span', {
    attrs: {
      "slot": "dropzoneDescription"
    },
    slot: "dropzoneDescription"
  }, [_vm._v("Arrastra la imagen que desees cargar o dale click al recuadro para buscar en tus archivos")]), _c('i', {
    staticClass: "fa fa-file-image-o",
    attrs: {
      "slot": "topIcon"
    },
    slot: "topIcon"
  })])], 1)])], 1) : _vm._e(), (_vm.mostrarConfirmacionEliminar) ? _c('div', {
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        _vm.mostrarConfirmacionEliminar = false
      }
    }
  }), _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarEliminar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEliminar = false
      },
      "do": _vm.eliminarFotoPerfil
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea eliminar su foto de perfil?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Eliminando...")] : [_vm._v("Eliminar")]], 2)])], 1)], 1) : _vm._e(), _c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "little"
  }, [_vm._v("Foto de Perfil")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), (_vm.isLoading) ? [_c('loading')] : [(_vm.pathFoto) ? _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm.pathFoto,
      "alt": "foto-usuario"
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "contenedor-acciones"
  }, [(!_vm.pathFoto) ? _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openModalAdjuntar
    }
  }, [_vm._m(0), _c('span', [_vm._v("Adjuntar")])]) : _c('button', {
    staticClass: "button is-small is-danger",
    on: {
      "click": function($event) {
        _vm.mostrarConfirmacionEliminar = true
      }
    }
  }, [_vm._m(1), _c('span', [_vm._v("Eliminar foto")])])])]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-upload is-small"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fbc6437e","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Datos_Personales_Foto_Perfil.vue
// module id = 971
// module chunks = 0